import * as http from './http';
import ApiService from './service';
import { LeaveRequestData, Leave } from '../models';

export default class LeaveService extends ApiService {
  leaveEndPoint = '/v1/leaves';
  async addLeave(data: LeaveRequestData): Promise<Leave[]> {
    const url = `${this.apiDomain}${this.leaveEndPoint}`;
    const response = await http.post<LeaveRequestData, Leave[]>(
      url,
      data,
      this.token
    );
    return response.data;
  }
}
